import { MsgLevel } from '../enum';

/**
 * The message to display
 */
export class Msg {
    message: string = '';
    level: MsgLevel = MsgLevel.info;
}